const GalleryImg = ({link, alt}) => {
    return (
        <>
            <div className={"col-md-6 col-lg-6 col-sm-12 col-xs-12 "}>
                <div className={"gallery-img"}>
                    <img src={link} alt={alt}/>
                </div>
            </div>
        </>
    );
}

export default GalleryImg;
